import { LeveragedTokensRemote } from "@modules/main/components/leveraged-tokens/infrastructure/leveraged-tokens.remote";
import { take } from "rxjs/operators";
import { GetLeveragedTokenTypeQuery } from "../../../../../api/graphql/staking/generated/leveragedTokens.token-type.service.graphql-gen";
import { Injectable } from "@angular/core";
import { LeveragedTokensStateService } from "@modules/main/components/leveraged-tokens/state/leveraged-tokens.state.service";
import { Observable } from "rxjs";
import {
	ILeverageTokenInfo,
	LeveragedTokensState
} from "@modules/main/components/leveraged-tokens/entities/leveraged-tokens-state.model";
import { LeverageTokenInfoState } from "./leveraged-token-info.state";
import { ILeverageTokenInfoSummaryViewModel } from "../leverage-token-info-summary/leverage-token-info-summary.interface";

@Injectable({
	providedIn: "root"
})
export class LeveragedTokensFacade {
	public constructor(
		private readonly leveragedTokensRemote: LeveragedTokensRemote,
		private readonly leveragedTokensStateSerivce: LeveragedTokensStateService,
		private readonly leverageTokenInfoState: LeverageTokenInfoState
	) {}

	public fetchLeveragedTokenType(assetId: string): void {
		this.leveragedTokensRemote
			.fetchLeveragedTokenType$(assetId)
			.pipe(take(1))
			.subscribe((result: GetLeveragedTokenTypeQuery) => {
				this.leveragedTokensStateSerivce.updateType(result.leveragedTokenType);
			});
	}

	public getLeveragedTokensState$(): Observable<LeveragedTokensState> {
		return this.leveragedTokensStateSerivce.getState$();
	}

	public fetchLeverageTokenInfo$(assetId: string): Observable<ILeverageTokenInfo> {
		return this.leveragedTokensRemote.fetchLeverageTokenInfo$(assetId);
	}

	public setLeverageTokenStateInfo$(info: ILeverageTokenInfoSummaryViewModel): void {
		return this.leverageTokenInfoState.updateInfo(info);
	}

	public getLeverageTokenStateInfo$(): Observable<ILeverageTokenInfoSummaryViewModel> {
		return this.leverageTokenInfoState.getInfo$();
	}

	public resetState(): void {
		this.leverageTokenInfoState.resetInfo();
	}
}
